'use client';

import Script from 'next/script';
import { FC } from 'react';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { COLORS } from '@/constants';
import { runtimeConfig } from '@/lib/runtimeConfig';
import { WlasContactBox, WlasIntroCard, WlasTabsPanel } from './components';
import {
  Container,
  MobileContactBoxWrapper,
  PageHeader,
  PageHeaderLeft,
} from './WlasWidgetScreen.styled';

export const WlasWidgetScreen: FC = () => {
  const t = useTranslations('wlasWidget');

  return (
    <>
      <Script
        src={`${runtimeConfig.WLAS_BASE_URL ?? ''}alleimmobilien-wlas-widget.js`}
        strategy="afterInteractive"
      />

      <Container>
        {/* ── Page header ── */}
        <PageHeader>
          <PageHeaderLeft>
            <Typography
              component="h1"
              fontSize={30}
              fontWeight={700}
              color={COLORS['primary/900']}
              lineHeight={1}
            >
              {t('title')}
            </Typography>
            <Typography fontSize={14} color={COLORS['neutral/500']} mt={0.5}>
              {t('subtitle')}
            </Typography>
          </PageHeaderLeft>
        </PageHeader>

        {/* ── Intro card (always visible) ── */}
        <WlasIntroCard />

        {/* ── Tabs ── */}
        <WlasTabsPanel />

        {/* ── Contact box (mobile only — desktop shows it in sidebar) ── */}
        <MobileContactBoxWrapper>
          <WlasContactBox />
        </MobileContactBoxWrapper>
      </Container>
    </>
  );
};
